<template>
  <div class="jazzterdays_intro">
    <Header
      v-bind:header="header"
      class="pb-16 pb-xl-0 pb-lg-0 pb-md-0 pd-sm-0"
    ></Header>

    <v-container pt-0 class="non_bg notecontainer">
    <NoteCircle v-bind:config="noteCircle1"></NoteCircle>
      <v-row wrap class="justify-end">
        <v-col :cols="12" sm="8" md="7" lg="9" xl="9">
          <ImageTile v-bind:quote="imgquote"></ImageTile>
        </v-col>
      </v-row>
    </v-container>

    <div class="">
      <v-container class="light_bg top_space">
        <SubHeader v-bind:subheader="subheader"></SubHeader>
        <v-row class="justify-center justify-md-end mb-10">
          <v-col cols="10" xl="8" lg="8" md="8" sm="8">
            <RunningText v-bind:text="introText"></RunningText>
          </v-col>
        </v-row>
        <v-row wrap class="justify-center justify-md-start">
          <v-col :cols="12" xl="7" lg="9" md="9" sm="10">
            <QuoteTile v-bind:quoteSet="textquote"></QuoteTile>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- <div class="white_bg"></div> -->
    <v-container class="non_bg mb-16"> </v-container>
  </div>
</template>


<script>
import Header from "./Header.vue";
import SubHeader from "./SubHeader.vue";
import QuoteTile from "./QuoteTile.vue";
import ImageTile from "./ImageTile.vue";
import RunningText from "./RunningText.vue";
import NoteCircle from "./NoteCircle.vue";

export default {
  name: "JazzterdaysIntro",
  components: {
    Header,
    SubHeader,
    RunningText,
    QuoteTile,
    ImageTile,
    NoteCircle,
  },
  data() {
    return {
      header: "About",
      noteCircle1: {
        id: "about_c1",
        width: 550,
        top: -50,
        left: -600,
        style: "stroke-dasharray: 0.5;",
        strokeWidth: 4,
        transform:
          "translate(calc(calc(calc(var(--parallax-value) * 0.8px)) + 0px), calc(var(--parallax-value) * 0.4px)) rotateZ(calc(var(--parallax-value) * 0.7deg))",
        maxLimit: 750,
        minLimit: 0,
      },
      subheader:
        "Eine magische Nacht im berühmtesten Jazzclub aller Zeiten: <br> dem BIRDLAND in NEW YORK",
      introText:
        "<p> Es ist wieder soweit: " +
        "Nur für eine Nacht öffnet das New Yorker BIRDLAND seine Pforten. Am Tresen sinniert Barkeeper Walter (Sascha Rotermund/Hans-Jörg Frey) über die große Zeit des legendären Jazzclubs - mit Jazz-Ikonen wie Miles Davis, Billie Holiday, Charlie Parker und Nina Simone. Im Club probt eine Jazzsängerin (San Glaser) und kann es nicht fassen, dass die Wiedereröffnung einmalig bleiben soll. Mit Text, Sound und Projektionen lässt der Hamburger Autor und Musiker Volker Präkelt die große Zeit des Jazz auferstehen. </p>" +
        "<p>Die „Clubband“ besteht aus Top-Musikern der Hamburger Jazzszene: Arnd Geise (Bass, MD), Johannes Wennrich/Henrik Wehnert (Gitarre), Mischa Schumann (Piano), Ralph Reichert (Sax) und Tobias Held (Drums). Eigenkompositionen ergänzen Standards wie „Lullaby of Birdland“, „I Get A Kick Out Of You“, „My Funny Valentine“, „God Bless the Child” oder „Cantaloupe Island”.</p>",
      imgquote: {
        withImage: true,
        img: {
          url: "/intro/scene_NY.jpeg",
          alt: "Szene New York",
        },
      },
      textquote: {
        quotes: [
          {
            quoteLines: [
              {
                id: 1,
                text: "Die Geschichte der Großen des Jazz auf einer Bühne.",
              },
              {
                id: 2,
                text:
                  "JAZZTERDAYS - ein hinreißender Abend mit fantastischer live-Musik, Erzählungen und eindrucksvollen Projektionen, den ich nicht nur Jazzfreunden empfehlen kann!",
              },
            ],
            author: "Reinhold Beckmann (TV-Mann & Musiker)",
          },
        ],
        withImage: true,
        img: {
          url: "/news/halle.jpeg",
          alt: "Halle 424",
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>

.notecontainer {
  position: relative;
}
</style>